// Interface for search service.
export interface ISearch {
	id: string;
	name: string;
}
export interface ITaxonomy {
	id: string;
	name: string;
	parentId?: string | null;
	createdAt?: Date;
}

// Interface for languages
export interface LanguagesResponse {
	languages: ILanguage[];
}

export interface ILanguage {
	id: string;
	name: string;
}

export interface EthnicityResponse {
	ethnicities: IEthnicity[];
	total: number;
}

export interface IEthnicity {
	id: number;
	name: string;
}

export interface ITaxonomyGroupResponse {
	id: number;
	context: ITaxonomyGroupContext;
	taxonomyId: ITaxonomy['id'];
	icon?: string;
	name: string;
	children: ITaxonomyGroupResponse[];
}

export enum ITaxonomyGroupContext {
	MoodTrackerReason = 'mood_tracker_reason',
	MoodTrackerEmotion = 'mood_tracker_emotion',
	SessionReason = 'session_reason',
	ProfessionalReason = 'professional_reason',
}
